/**
 * @generated SignedSource<<7e8e00950ac2e8fb2591f007c09b6ec9>>
 * @relayHash 6a26135ba70e4592523b9c418826be0f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a26135ba70e4592523b9c418826be0f

import { ConcreteRequest } from 'relay-runtime';
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type deTimeToTreatQuery$variables = Record<PropertyKey, never>;
export type deTimeToTreatQuery$data = {
  readonly timesToTreatByPointOfCare: ReadonlyArray<{
    readonly pointOfCare: PointOfCareType;
    readonly timesToTreat: ReadonlyArray<TimeToTreatType>;
  }>;
};
export type deTimeToTreatQuery = {
  response: deTimeToTreatQuery$data;
  variables: deTimeToTreatQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "timesToTreatByPointOfCare",
    "args": null,
    "concreteType": "PointOfCareTimesToTreat",
    "kind": "LinkedField",
    "name": "de_timesToTreatByPointOfCare",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pointOfCare",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timesToTreat",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "deTimeToTreatQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "deTimeToTreatQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "6a26135ba70e4592523b9c418826be0f",
    "metadata": {},
    "name": "deTimeToTreatQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8c5ca0517358aea01299c3ce4e67dbcc";

export default node;
